/**
 * 공통 아이콘
 */
export const commonImage = {
  logoGsil: '/assets/icon/logo/icon-logo-gsil.svg',
  calender: '/assets/icon/common/icon-calender.svg',
  laguage: '/assets/icon/common/icon-language.svg',
  logout: '/assets/icon/common/icon-logout.svg',
  mypage: '/assets/icon/common/icon-mypage.svg',
  modalClose: '/assets/icon/common/icon-close.svg',
  carouselStop: '/assets/icon/common/icon-stop.svg',
  carouselPlay: '/assets/icon/common/icon-play.svg',
  search: '/assets/icon/common/icon-search.svg',
  searchWhite: '/assets/icon/common/icon-search-white.svg',
  cancel: '/assets/icon/common/icon-cancel.svg',
  camera: '/assets/icon/common/icon-camera.svg',
  cctv: '/assets/icon/common/icon-cctv.svg',
  delete: '/assets/icon/common/icon-delete.svg',
  file: '/assets/icon/common/icon-file.svg',
  fileUploadOff: '/assets/icon/common/icon-upload-file.svg',
  fileUploadOn: '/assets/icon/common/icon-upload-file-on.svg',
  alarmNormal: '/assets/icon/common/icon-alarm-normal.svg',
  alarmUnread: '/assets/icon/common/icon-alarm-unread.svg',
  fileDownload: '/assets/icon/common/icon-file-download.svg',
  download: '/assets/icon/common/icon-download.svg'
};

/**
 * 메뉴 아이콘
 */
export const menuImage = {
  menuClose: '/assets/icon/menu/icon-menu-close.svg',
  menuOpen: '/assets/icon/menu/icon-menu-open.svg'
};

/**
 * 화살표 아이콘
 */
export const arrowImage = {
  arrowDropDown: '/assets/icon/arrow/icon-arrow-dropdown.svg',
  arrowNext: '/assets/icon/arrow/icon-arrow-next.svg',
  arrowPrev: '/assets/icon/arrow/icon-arrow-prev.svg',
  arrowTriangle: '/assets/icon/arrow/icon-arrow-triangle.svg'
};

/**
 * 체크박스 아이콘
 */
export const fileImage = {
  avi: '/assets/icon/file/icon-avi.svg',
  css: '/assets/icon/file/icon-css.svg',
  doc: '/assets/icon/file/icon-doc.svg',
  eps: '/assets/icon/file/icon-eps.svg',
  jpg: '/assets/icon/file/icon-jpg.svg',
  jpeg: '/assets/icon/file/icon-jpg.svg',
  mp3: '/assets/icon/file/icon-mp3.svg',
  pdf: '/assets/icon/file/icon-pdf.svg',
  png: '/assets/icon/file/icon-png.svg',
  psd: '/assets/icon/file/icon-psd.svg',
  txt: '/assets/icon/file/icon-txt.svg',
  xls: '/assets/icon/file/icon-xls.svg',
  zip: '/assets/icon/file/icon-zip.svg',
  pptx: '/assets/icon/file/icon-pptx.svg',
  etc: '/assets/icon/file/icon-etc.svg'
};

/**
 * 상태값 별 아이콘
 */
export const statusImage = {
  editSquare: '/assets/icon/status/icon-edit-square.svg',
  trashDelete: '/assets/icon/status/icon-trash-delete.svg',
  deleteActive: '/assets/icon/status/icon-delete-active.svg',
  add: '/assets/icon/status/icon-add.svg'
};

/**
 * 로그인 이미지
 */
export const loginImage = {
  base: '/assets/image/login/main.png',
  inquiry: '/assets/image/login/image-login-inquiry.png',
  invitation: '/assets/image/login/image-login-invitation.png',
  leftLogo: '/assets/image/login/login-logo.png',
  rightLogo: '/assets/image/login/login-right-logo.svg'
};

export const approvalImage = {
  denied: '/assets/image/denied.png'
};

export const ciImage = {
  gsilLogoNormal: '/assets/image/ci/gsil-logo-normal.svg',
  logo4s: '/assets/image/ci/logo-4s.svg',
  logo4sWhite: '/assets/image/ci/logo-saf-white.svg',
  logoSamsungWhite: '/assets/image/ci/logo-samsung-white.svg',
  logoSamsungBlue: '/assets/image/ci/logo-samsung-blue.svg'
};

/**
 * 환경 이미지
 * @type {{rain, common, temperature, humidity, barometer, windDirection, setting, wind, humidity2, wind2, rain2}}
 */
export const environmentIcon = {
  common: '/assets/image/environment/common.svg',
  humidity: '/assets/image/environment/humidity.svg',
  barometer: '/assets/image/environment/barometer.svg',
  rain: '/assets/image/environment/rain.svg',
  setting: '/assets/image/environment/setting.svg',
  temperature: '/assets/image/environment/temparature.svg',
  wind: '/assets/image/environment/wind.svg',
  windDirection: '/assets/image/environment/wind_direction.svg',
  humidity2: '/assets/icon/weather/icon-humidity.svg',
  wind2: '/assets/icon/weather/icon-wind.svg',
  rain2: '/assets/icon/weather/icon-umbrella.svg'
};

/**
 * 깃발 이미지
 * @type {{red: *, orange: *, green: *, yellow: *}}
 */
export const flagsIcon = {
  red: '/assets/image/environment/flag-red.png',
  orange: '/assets/image/environment/flag-orange.png',
  yellow: '/assets/image/environment/flag-yellow.png',
  green: '/assets/image/environment/flag-green.png'
};

/**
 * 환경 작은 아이콘
 * @type {{rain, common, temperature, humidity, barometer, wind}}
 */
export const environmentMiniIcon = {
  common: '/assets/icon/environment/icon-pm.svg',
  humidity: '/assets/icon/environment/icon-humidity.svg',
  barometer: '/assets/icon/environment/icon-barometer.svg',
  rain: '/assets/icon/environment/icon-rain.svg',
  temperature: '/assets/icon/environment/icon-temperature.svg',
  wind: '/assets/icon/environment/icon-wind.svg'
};

export const weatherImage = {
  manyCloud: '/assets/image/environment/weather_many_cloud.svg'
};

/**
 * PPE 보호장비 이미지
 */
export const ppeImages = {
  ppe: '/assets/image/ppe/image-ppe.png'
};

export const weatherIcons = {
  '01d': '/assets/icon/weather/01d.svg',
  '02d': '/assets/icon/weather/02d.svg',
  '03d': '/assets/icon/weather/03d.svg',
  '04d': '/assets/icon/weather/04d.svg',
  '09d': '/assets/icon/weather/09d.svg',
  '10d': '/assets/icon/weather/10d.svg',
  '11d': '/assets/icon/weather/11d.svg',
  '13d': '/assets/icon/weather/13d.svg',
  '50d': '/assets/icon/weather/50d.svg',
  '01n': '/assets/icon/weather/01d.svg',
  '02n': '/assets/icon/weather/02d.svg',
  '03n': '/assets/icon/weather/03d.svg',
  '04n': '/assets/icon/weather/04d.svg',
  '09n': '/assets/icon/weather/09d.svg',
  '10n': '/assets/icon/weather/10d.svg',
  '11n': '/assets/icon/weather/11d.svg',
  '13n': '/assets/icon/weather/13d.svg',
  '50n': '/assets/icon/weather/50d.svg'
};

export const findWeatherIcon = (iconName) => {
  const iconTitle = iconName.replaceAll('n', 'd'.replaceAll('.png', '').replaceAll(' ', ''));
  return weatherIcons[iconTitle];
};

/** Clock Image */
export const clockImages = {
  clock: '/assets/image/clock/image-clock-bg.png',
  hour: '/assets/image/clock/image-clock-hour.svg',
  minute: '/assets/image/clock/image-clock-minute.svg',
  second: '/assets/image/clock/image-clock-second.svg'
};

/** Tbm Icons */
export const tbmIcons = {
  person_total: '/assets/icon/tbm/person_total.svg',
  person_in: '/assets/icon/tbm/person_in.svg',
  person_out: '/assets/icon/tbm/person_out.svg',
  person_complete: '/assets/icon/tbm/person_complete.svg'
};

/**
 * NFC 카드 아이콘
 */
export const nfcCardIcons = {
  company: '/assets/icon/nfc/Icon_Company.png',
  position: '/assets/icon/nfc/Icon_Position.png',
  nationality: '/assets/icon/nfc/Icon_Nationality.png',
  bloodType: '/assets/icon/nfc/Icon_Blood Type.png',
  trainingDate: '/assets/icon/nfc/Icon_Training Date.png',
  emptyProfile: '/assets/icon/nfc/empty_profile.svg'
};

/** Samsung Dashboard */
export const samsungMapImages = {
  marker_green: '/assets/icon/samsung-dashboard/marker-green.svg',
  marker_red: '/assets/icon/samsung-dashboard/marker-red.svg'
};

export const clusterImages = {
  cluster_gray: '/assets/icon/cluster/cluster-gray.svg',
  cluster_green: '/assets/icon/cluster/cluster-green.svg',
  cluster_orange: '/assets/icon/cluster/cluster-orange.svg',
  cluster_red: '/assets/icon/cluster/cluster-red.svg'
};

/** ptw */
export const ptwImages = {
  weather01: '/assets/icon/global/dashboard-weather-01.svg',
  timeLineLeft: '/assets/icon/global/time-line-left.svg',
  timeLineRight: '/assets/icon/global/time-line-right.svg',
  timeLineWarn: '/assets/icon/global/time-line-warn.svg',
  timeLineRisk: '/assets/icon/global/time-line-risk.svg',

  totalCctv: '/assets/icon/global/total-cctv.svg',
  totalGasDetector: '/assets/icon/global/total-gas-detector.svg',
  totalGeneralWork: '/assets/icon/global/total-general-work.svg',
  totalHighRiskWork: '/assets/icon/global/total-high-risk-work.svg',
  totalSmartHook: '/assets/icon/global/total-smart-hook.svg',
  mapArrowRight: '/assets/icon/global/map-arrow-right.svg',
  mapArrowBottom: '/assets/icon/global/map-arrow-bottom.svg',

  lsIcon: '/assets/icon/global/ls-icon.svg',
  dashboardPopupX: '/assets/icon/global/dashboard-popup-x.svg',
  alarmPause: '/assets/icon/global/alarm-pause.svg',
  alarmPlay: '/assets/icon/global/alarm-play.svg',

  close: '/assets/icon/map/close-01.svg',
  toggle: '/assets/icon/map/toggle-02.svg',
};

export const ptwMapImages = {
  hookNormal: '/assets/icon/map/db_map_point_04_00.svg',
  hookSafety: '/assets/icon/map/db_map_point_04_02.svg',
  hookDanger: '/assets/icon/map/db_map_point_04_01.svg',
  cctv: '/assets/icon/map/db_map_point_08.svg',
  iot: '/assets/icon/map/db_map_point_06.svg',
  generalWork: '/assets/icon/map/db_map_point_02_01.svg',
  highRiskWork: '/assets/icon/map/db_map_point_07.svg',
  link: '/assets/icon/map/link-img.svg'
};
